import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PickListModule } from 'primeng/picklist';
import { Column } from '@src/app/modules/table/types';

@Component({
  selector: 'table-columns-setting',
  standalone: true,
  imports: [FormsModule, PickListModule],
  templateUrl: './columns-setting.component.html',
  styleUrl: './columns-setting.component.scss',
  changeDetection: ChangeDetectionStrategy.Default,
})
export class ColumnsSettingComponent {
  @Input() allColumns: Array<Column> = [];

  @Input() selectedColumns: Array<Column> = [];
  @Output() selectedColumnsChange = new EventEmitter<Array<Column>>();

  get hidedColumns(): Array<Column> {
    return this.allColumns.filter(
      column => !this.selectedColumns?.find(selectedColumn => selectedColumn.field === column.field),
    );
  }

  onEmit() {
    this.selectedColumnsChange.emit(this.selectedColumns);
  }
}
